<template>
  <div class="account__item account__item--edit account__item--gradient">
    <form class="account__content" @input="error = false">
      <h2 class="title--l">{{ getUiString(['password_reset', 'title']) }}</h2>
      <div class="text--emphasis">{{ getUiString(['password_reset', 'text']) }}</div>
      <lennoc-input id="current-password" type="password" v-model="oldPassword" :label="getUiString(['password_reset', 'current_password'])" :domClass="getErrorClass"></lennoc-input>
      <div class="form__row">
        <lennoc-input id="newPassword" type="password" v-model="newPassword_1" :label="getUiString(['password_reset', 'new_password'])" :domClass="getErrorClass"></lennoc-input>
        <lennoc-input id="newPassword2" type="password" v-model="newPassword_2" :label="getUiString(['password_reset', 'confirm_password'])" :domClass="getErrorClass"></lennoc-input>
        <div class="form__group--error">
          <div class="error" v-if="error">{{ errorMessage }}
          <lennoc-expandable-content
            @triggered="$emit('setHeight')"
            v-bind:label="this.getUiString(['password_reset', 'read_more'])"
            v-if="errorMessageDescription !== ''">
            <div class="text">{{ errorMessageDescription }}</div>
          </lennoc-expandable-content>
          </div>
        </div>
      </div>
      <button type="submit" class="button button--prim" @click.prevent="saveSettings">{{ getUiString(['my_account', 'contact_info', 'save_button_text']) }}</button>
      <a class="link link--edit" href="#" @click.prevent="$emit('cancel-edit-login')">
        <lennoc-icon image="edit"/>
        <span>{{ getUiString(['my_account', 'contact_info', 'cancel_button_text']) }}</span>
      </a>
    </form>
    <lennoc-spinner v-if="busy" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const MINIMUM_PASSWORD_LENGTH = 8

export default {
  name: 'InlogDataEdit',
  data () {
    return {
      busy: false,
      error: false,
      errorMessage: '',
      errorMessageDescription: '',
      oldPassword: '',
      newPassword_1: '',
      newPassword_2: ''
    }
  },
  methods: {
    getTouchedClass (member) {
      return this.account[member] !== '' ? 'form__group--touched' : ''
    },
    async saveSettings () {
      this.error = false
      if (this.newPassword_1 !== this.newPassword_2) {
        this.error = true
        this.errorMessage = this.getUiString(['password_reset', 'passwords_dont_match'])
        this.errorMessageDescription = ''
      } else if (!this.testPassword(this.newPassword_1)) {
        this.error = true
        this.errorMessage = this.getUiString(['password_reset', 'requirements'])
        this.errorMessageDescription = ''
      } else {
        const data = { oldPassword: this.oldPassword, newPassword: this.newPassword_1 }
        this.busy = true
        try {
          const result = await this.$store.dispatch('account/updateLogin', data)
          if (result.status === 500) {
            this.error = true
            this.errorMessage = `${this.getUiString(['password_reset', 'failed_unknown'])}`
            if (result.data === undefined || result.data === null) {
              this.errorMessageDescription = `${result.statusText}`
            } else {
              this.errorMessageDescription = `${result.status}: ${result.data.message}`
            }
          } else {
            this.$emit('end-edit-login', 'ok')
          }
        } catch (error) {
          this.error = true
          this.errorMessage = `${this.getUiString(['password_reset', 'failed_unknown'])}`
          this.errorMessageDescription = `${error}`
        }
        this.busy = false
      }
    },
    testPassword (pw) {
      if (pw.length < MINIMUM_PASSWORD_LENGTH) {
        return false
      }
      if (pw.toUpperCase() === pw || pw.toLowerCase() === pw) {
        return false
      }
      return /\d+/.test(pw)
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    }),
    getErrorClass () {
      return this.error ? 'form__group--error' : ''
    }
  }
}
</script>
